import { z } from 'zod';

import { requiredString } from './primitives';

export const adminLoginSchema = z.object({
  email: requiredString('El email').email('Email inválido'),
  password: requiredString('La contraseña').min(6, 'Mínimo 6 caracteres'),
});
export type AdminLoginFields = z.infer<typeof adminLoginSchema>;

/* =====================================================================
   Forms admin — por juego.
   Los números los obtenemos desde RHF con `{ valueAsNumber: true }`,
   por eso no usamos z.coerce.number() aquí (causa mismatch z.input ≠ z.output).
===================================================================== */

export const questionFormSchema = z.object({
  cat: z.enum(['GenAI', 'Cloud', 'Analytics', 'eTribe']),
  q: requiredString('La pregunta').max(500),
  a0: requiredString('La opción A'),
  a1: requiredString('La opción B'),
  a2: requiredString('La opción C'),
  a3: requiredString('La opción D'),
  c: z.number().int().min(0).max(3),
  d: z.number().int().min(1).max(3),
});
export type QuestionFormFields = z.infer<typeof questionFormSchema>;

export const scenarioFormSchema = z.object({
  snum: z.number().int().positive(),
  title: requiredString('El título'),
  desc: requiredString('La descripción'),
  industry: requiredString('La industria'),
  correctText: requiredString('Tecnologías correctas (una por línea)'),
  allText: requiredString('Pool de tecnologías (formato: emoji|nombre, una por línea)'),
});
export type ScenarioFormFields = z.infer<typeof scenarioFormSchema>;

export const caseFormSchema = z.object({
  title: requiredString('El título'),
  cluesText: requiredString('Pistas (una por línea, mínimo 5)'),
  optsText: requiredString('Opciones (una por línea, mínimo 4 — el título debe estar)'),
});
export type CaseFormFields = z.infer<typeof caseFormSchema>;

export const pokemonFormSchema = z.object({
  name: requiredString('El nombre'),
  type: z.enum(['pokemon', 'bigdata']),
  pokemonId: z.number().int().min(0).optional(),
  description: requiredString('La descripción'),
  emoji: z.string().max(8).optional().or(z.literal('')),
});
export type PokemonFormFields = z.infer<typeof pokemonFormSchema>;
